// opervex-frontend/src/Opervex/Accounting/index.js

import Branches from "./Branches";
import Cities from "./Cities";
import States from "./States";
import FiscalPeriod from "./FiscalPeriod";
import Customers from "./Customers";
import Vendors from "./Vendors";
import CostCenters from "./CostCenters";

class Accounting {
  constructor(api) {
    this.Branches = new Branches(api);
    this.Cities = new Cities(api);
    this.States = new States(api);
    this.FiscalPeriods = new FiscalPeriod(api);
    this.Customers = new Customers(api);
    this.Vendors = new Vendors(api);
    this.CostCenters = new CostCenters(api);
  }
}

export default Accounting;
